export default {
  setOrderInfo(state, orderInfo) {
    state.orderInfo = orderInfo
  },
  setAccountBalance(state, accountBalance) {
    state.accountBalance = accountBalance
  },
  setCode(state, code) {
    state.code = code
  },
  setOrderStatus(state, orderStatus) {
    state.orderStatus = orderStatus
  },
  setPending(state, pending) {
    state.pending = pending
  },
  setCodeLoading(state, codeLoading) {
    state.codeLoading = codeLoading
  },
}
